let hostUrl = 'http://localhost:8080';

if (process.env.NODE_ENV === 'production') {
  hostUrl = 'https://marvelapp.com';
}

export const HOST = hostUrl;



// WEBPACK FOOTER //
// ./src/configs/urls.js